import { ITreeStructure } from '../models/treeStructure'

import { getItemsMap } from './getItemsMap'

export const assignChildToParent = (original: ITreeStructure[]) => {
  const itemsMap = getItemsMap(original)
  const flatData = structuredClone(original) as ITreeStructure[]

  for (let i = 0; i < flatData.length; i++) {
    const item = flatData[i]
    if (item.parentId === null) {
      continue
    }

    const mapKey = item.parentId
    const parentIndex = itemsMap[mapKey]
    const parent = flatData[parentIndex]
    if (!parent) {
      continue
    }

    parent.hasChildren = true
    item.parent = flatData[parentIndex]
    parent.nestedItems.push(item)
  }

  return flatData
}
